import { render, staticRenderFns } from "./PeakFactors.vue?vue&type=template&id=a1023efc&scoped=true&"
import script from "./PeakFactors.vue?vue&type=script&lang=js&"
export * from "./PeakFactors.vue?vue&type=script&lang=js&"
import style0 from "./PeakFactors.vue?vue&type=style&index=0&id=a1023efc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1023efc",
  null
  
)

export default component.exports